import { ILocalizer } from "../../../Core/Localization/ILocalizer";

import { ICustomValidationLocalizer } from "./ICustomValidationFunctionCallContext";

export class CustomValidationLocalizer implements ICustomValidationLocalizer {
    readonly #localizer: ILocalizer;

    public constructor(localizer: ILocalizer) {
        this.#localizer = localizer;
    }

    public translate(message: string): string {
        return this.#localizer.translate(message);
    }
}
